import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=bf8cbc30&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=bf8cbc30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8cbc30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf8cbc30')) {
      api.createRecord('bf8cbc30', component.options)
    } else {
      api.reload('bf8cbc30', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=bf8cbc30&scoped=true&", function () {
      api.rerender('bf8cbc30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2C07swQ0fYdp1/JS/comp/SearchFilterTokens.vue"
export default component.exports